import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React from 'react';
import classNames from 'classnames';
import styles from './Reorder.module.scss';
import { useReorderContext } from './ReorderContext';
import { Button, ButtonProps, Icon, IconList } from 'components/core';

type Props = {
  children: React.ReactNode;
  id: string | number;
  className?: string;
  dragHandleSize?: ButtonProps['size'];
};

export const ReorderItem = ({
  children,
  id,
  className,
  dragHandleSize,
}: Props) => {
  const { enabled } = useReorderContext();
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({
    id,
  });

  const reorderStyle = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  if (enabled) {
    return (
      <li
        ref={setNodeRef}
        style={reorderStyle}
        className={classNames(styles.ReorderItem, className)}
      >
        <Button
          {...attributes}
          {...listeners}
          type="neutral"
          variant="ghost"
          size={dragHandleSize}
          iconOnly
          className={styles.DragHandle}
        >
          <Icon icon={IconList.solid.faGripDotsVertical} size="xs">
            Drag Handle
          </Icon>
        </Button>
        {children}
      </li>
    );
  } else {
    return (
      <li className={classNames(styles.ReorderItem, className)}>{children}</li>
    );
  }
};
